import { isMobile } from "@modules/util/device"
import { initSwiperContainer } from "@modules/util/swiper"
import type { SwiperContainer } from "swiper/element"
import { getSwiperConfig } from "./swiper-config"

const swiperContainer = document.getElementById("city-highlights-container") as SwiperContainer
const sliderType = isMobile() ? "slider" : "coverflow"
if (swiperContainer) {
    initSwiperContainer(swiperContainer, getSwiperConfig("idk", 4, sliderType))
}
